import { GraphQLClient, RequestDocument } from 'graphql-request'
import { v4 as uuidv4 } from 'uuid'
import environment from '../environment'

type Params = { document: RequestDocument; options?: Record<string, unknown> }

const graphQLClient = new GraphQLClient(`${environment.gatewayEndpoint}/graphql`)

const useGraphQLClient = () => {
  return async <T>({ document, options = {} }: Params): Promise<T> => {
    const correlationId = uuidv4()
    const response = await graphQLClient.request({
      document,
      variables: options,
      requestHeaders: {
        'X-Correlation-Id': correlationId,
      },
    })

    return response as T
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getGraphQLClient = (req?: any) => {
  return async <T>({ document, options = {} }: Params): Promise<T> => {
    const correlationId = uuidv4()
    const response = await graphQLClient.request({
      document,
      variables: options,
      requestHeaders: {
        'X-Correlation-Id': correlationId,
      },
    })

    return response as T
  }
}

export default useGraphQLClient
